export default __webpack_public_path__ + "static/media/empty-star.e0905f0b.svg";